import {EntityService} from '../../service/EntityService';

export class MGateWayService extends EntityService {

  static entity = 'app/m-gate-way';

  static searchTaxCode(mst: string): Promise<any> {
    return this.axios.get(`${this.entity}/re-search-tax-code`, {params: {mst}}).then(res => res.data);
  }

  static getResult(actionId: string, type: string): Promise<any> {
    return this.axios.get(`${this.entity}/result/${actionId}`, {params: {type}}).then(res => res.data);
  }

  static rollbackStatus(type: string, ids: Array<string>): Promise<any> {
    return this.axios.post(`${this.entity}/rollback-staus`, {type, ids}).then(res => res.data);
  }

  static revertStatus(searchInvoice: any): Promise<any> {
    return this.axios.post(`${this.entity}/revert-status`,searchInvoice).then(res => res.data);
  }

  static getXml(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/download-xml`).then(res => res.data);
  }

  static downloadXml(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/download-xml`, {responseType: 'blob'}).then(res => res.data);
  }

  static getPdfUrl(id: string): string {
    return `${this.baseURL}/${this.entity}/${id}/downloaf-pdf`;
  }

  static reloadAuthorisedCode(params: any): Promise<any> {
    return this.axios.post(`${this.entity}/reload-authorised-code`, params).then(res => res.data);
  }

}
